import { useCallback } from "react";
import EntitySearchBox from "../../common/crud/EntitySearchBox";
import useBusiness from "../../hooks/store/business";
import usePermissions from "../../hooks/usePermissions";

export const BusinessSearch = () => {
  const {
    getBusinessAction,
    setPageNumberAction,
    setRowsPerPageAction,
    searchBusinessAction,
    rowsPerPage,
    page,
    getBusinessWithClientAction,
    clientSearchAction,
    getBusinessRoleAction,
  } = useBusiness();
  const { businessId, capabilities, clientId, isBusiness, isClient } =
    usePermissions();

  const enabled =
    Boolean(capabilities?.canViewBusinesses) &&
    !((isClient && !clientId) || (isBusiness && !businessId));

  const handleResetPagination = useCallback(
    (paginationState) => {
      setRowsPerPageAction(paginationState.rowsPerPage);
      setPageNumberAction(paginationState.page);
    },
    [setPageNumberAction, setRowsPerPageAction]
  );

  const loadPage = useCallback(
    ({ limit, offSet, signal }) => {
      if (isClient && clientId) {
        getBusinessWithClientAction({
          clientId,
          limit,
          offSet,
        });
        return;
      }

      if (isBusiness && businessId) {
        getBusinessRoleAction({
          businessId,
        });
        return;
      }

      getBusinessAction({
        limit,
        offSet,
        signal,
      });
    },
    [
      businessId,
      clientId,
      getBusinessAction,
      getBusinessRoleAction,
      getBusinessWithClientAction,
      isBusiness,
      isClient,
    ]
  );

  const searchPage = useCallback(
    ({ limit, name, offSet, signal }) => {
      if (isClient && clientId) {
        clientSearchAction({
          clientId,
          limit,
          offSet,
          name,
          signal,
        });
        return;
      }

      searchBusinessAction({
        limit,
        offSet,
        name,
        signal,
      });
    },
    [clientId, clientSearchAction, isClient, searchBusinessAction]
  );

  return (
    <EntitySearchBox
      enabled={enabled}
      hidden={isBusiness && Boolean(businessId)}
      loadPage={loadPage}
      onResetPagination={handleResetPagination}
      page={page}
      placeholder="Search Business"
      rowsPerPage={rowsPerPage}
      searchPage={searchPage}
      sx={{ maxWidth: 500, display: "flex", justifyContent: "end" }}
    />
  );
};
